import React, { useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import AnalyticsReportView from './AnalyticsReportView';
import { REPORT_HEADER_LIST, REPORT_HEADER_TYPE_ENUM } from './reportsConfig';
import { triggerNotification } from '../../../helpers/notificationHelper';

const ReportView = ({
  entityId,
  reportConfigs,
  onGenerateReport,
  urlBase,
  reportResult,
  reportViewType,
  isAdminView,
  viewAsOptions,
  resourcesLoading,
  redirectPath
}) => {
  const hasFetched = useRef(false);
  const { search } = useLocation();
  const fromLocation = new URLSearchParams(search).get('from');
  const [reportLoading, setReportLoading] = useState(false);

  const onFetchAnalyticsReport = (uuid, requestData) => {
    setReportLoading(true);
    onGenerateReport(
      {
        uuid,
        ...requestData,
        filters:
          requestData.filters?.map((filter) => {
            const reportHeader = REPORT_HEADER_LIST.find(
              (r) => r.value === filter.field
            );

            if (reportHeader?.type === REPORT_HEADER_TYPE_ENUM.CURRENCY) {
              return {
                ...filter,
                values: filter.values.map((v) => (v * 100).toString())
              };
            }
            return filter;
          }) || []
      },
      () => setReportLoading(false),
      (error) => {
        setReportLoading(false);
        triggerNotification(error);
      }
    );

    hasFetched.current = true;
  };

  return (
    <AnalyticsReportView
      entityId={entityId}
      isAdminView={isAdminView}
      loading={reportLoading}
      onFetchReport={onFetchAnalyticsReport}
      redirectPath={redirectPath}
      reportConfigs={reportConfigs}
      reportResult={hasFetched.current ? reportResult : null}
      reportViewType={reportViewType}
      resourcesLoading={resourcesLoading}
      viewAsOptions={viewAsOptions}
    />
  );
};

ReportView.propTypes = {
  entityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isAdminView: PropTypes.bool,
  onGenerateReport: PropTypes.func,
  redirectPath: PropTypes.string,
  reportConfigs: PropTypes.array,
  reportResult: PropTypes.object,
  reportViewType: PropTypes.string,
  resourcesLoading: PropTypes.bool,
  urlBase: PropTypes.string,
  viewAsOptions: PropTypes.array
};

export default ReportView;
